import { ICommon, StatusUpdateResponse } from "./../pages/reviews/types";
import { token } from "./../utils/token.utils";
import { getRequest, updateRequest } from "./api.service";
import { ActionType, API_URL } from "../utils/constants";
import { PartnerData, PartnerResponse } from "../pages/reviews/types";
import { TeacherStatus } from "./teacher.service";
import showToast from "../utils/show.toast";

export enum PartnerStatus {
  REGISTERED = "registered",
  ACCEPTED = "accepted",
  VERIFIED = "verified",
  SUSPENDED = "suspended",
  REJECTED = "rejected",
  DEACTIVATED = "deactivated",
}

export const listPartnersByStatus = async (
  status: string
): Promise<PartnerResponse> => {
  const data = await getRequest<PartnerResponse>(
    `${API_URL}/merchants/partners/by-status?status=${status}`
  );
  return data;
};

export const getPartnerDetails = async (endpoint: string): Promise<any> => {
  const data = await getRequest<PartnerData>(`${API_URL}/${endpoint}`);
  return data.result;
};

export const getTotalPartnersByStatus = async (): Promise<any> => {
  const data = await getRequest<{ result: { users: number } }>(
    `${API_URL}/merchants/partners/status-counts`
  );
  // console.log(data);
  return data.result;
};

export const updateStatus = async (
  endpoint: string,
  body: { status: PartnerStatus }
): Promise<ICommon> => {
  const data = await updateRequest<ICommon>(`${API_URL}/${endpoint}`, body);
  return data;
};
